"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GreetingParent = exports.AccountIcon = exports.Name = exports.Content = exports.Modal = exports.X = exports.Menu = exports.ButtonContainer = exports.Button = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactFeather = require("react-feather");

var _reactDiv100vh = _interopRequireDefault(require("react-div-100vh"));

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var Button = _styledComponents["default"].button(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  background: ", ";\n  border: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  appearance: none;\n  color: ", ";\n"], ["\n  background: ", ";\n  border: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  appearance: none;\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.white;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
});

exports.Button = Button;
var ButtonContainer = (0, _styledComponents["default"])(_slice.Flex)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  position: fixed;\n  width: 52px;\n  height: 84px;\n  background-color: ", ";\n  top: 0;\n  padding: 8px;\n"], ["\n  position: fixed;\n  width: 52px;\n  height: 84px;\n  background-color: ", ";\n  top: 0;\n  padding: 8px;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.white;
});
exports.ButtonContainer = ButtonContainer;
var icon = (0, _styledComponents.css)(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  width: 40px;\n  height: 40px;\n  color: ", ";\n  cursor: pointer;\n"], ["\n  width: 40px;\n  height: 40px;\n  color: ", ";\n  cursor: pointer;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
});
var Menu = (0, _styledComponents["default"])(_reactFeather.Menu)(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)([" ", " "], [" ", " "])), icon);
exports.Menu = Menu;
var X = (0, _styledComponents["default"])(_reactFeather.X)(templateObject_5 || (templateObject_5 = (0, _tslib.__makeTemplateObject)([" ", " "], [" ", " "])), icon);
exports.X = X;
var Modal = (0, _styledComponents["default"])(_reactDiv100vh["default"])(templateObject_6 || (templateObject_6 = (0, _tslib.__makeTemplateObject)(["\n  padding-top: 84px;\n  position: relative;\n  z-index: 1002;\n  pointer-events: none;\n"], ["\n  padding-top: 84px;\n  position: relative;\n  z-index: 1002;\n  pointer-events: none;\n"])));
exports.Modal = Modal;
var Content = (0, _styledComponents["default"])(_slice.Box)(templateObject_7 || (templateObject_7 = (0, _tslib.__makeTemplateObject)(["\n  background-color: ", ";\n  height: 100%;\n  overflow-y: scroll;\n  text-align: center;\n  width: 100%;\n  font-size: 24px;\n  padding: 12px;\n  pointer-events: auto;\n"], ["\n  background-color: ", ";\n  height: 100%;\n  overflow-y: scroll;\n  text-align: center;\n  width: 100%;\n  font-size: 24px;\n  padding: 12px;\n  pointer-events: auto;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.white;
});
exports.Content = Content;
var Name = (0, _styledComponents["default"])(_slice.Headline).attrs({
  fontSize: [5, 5, 5, 5]
})(templateObject_8 || (templateObject_8 = (0, _tslib.__makeTemplateObject)(["\n  margin: 0 0 0 8px;\n  align-self: center;\n"], ["\n  margin: 0 0 0 8px;\n  align-self: center;\n"])));
exports.Name = Name;
var AccountIcon = (0, _styledComponents["default"])(_slice.Image)(templateObject_9 || (templateObject_9 = (0, _tslib.__makeTemplateObject)(["\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-block;\n"], ["\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-block;\n"])));
exports.AccountIcon = AccountIcon;
var GreetingParent = (0, _styledComponents["default"])(_slice.Flex)(templateObject_10 || (templateObject_10 = (0, _tslib.__makeTemplateObject)(["\n  align-items: center;\n  margin: 0 20px 20px 20px;\n"], ["\n  align-items: center;\n  margin: 0 20px 20px 20px;\n"])));
exports.GreetingParent = GreetingParent;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;